import { render, staticRenderFns } from "./Launchpad.vue?vue&type=template&id=0f649958&scoped=true"
import script from "./Launchpad.vue?vue&type=script&lang=js"
export * from "./Launchpad.vue?vue&type=script&lang=js"
import style0 from "./Launchpad.vue?vue&type=style&index=0&id=0f649958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f649958",
  null
  
)

export default component.exports